export default __webpack_public_path__ + "static/media/before_1_implants.92aeca8d.png";